<script setup lang="ts">
const { page, layout } = storeToRefs(useThemeEditorStore())

const route = useRoute()

const Data = computed(() => {
  if (route.query.isPreview) {
    return page.value
  }
  return layout.value
})
const { showLayout } = useUseLayout()
/**  过滤后的公告列表 */
const list = computed(() => {
  if (Data.value?.settings?.announcement?.blocks) {
    return Data.value?.settings?.announcement?.blocks?.filter((i: any) => !i.disabled) as Array<any>
  }
  return []
})

provide('headersDatas', Data)
</script>

<template>
  <div class="h-100% min-h-100vh flex flex-col">
    <component is="blocks-announcement" v-show="showLayout" v-if="list.length" :datas="Data" />
    <component is="blocks-headers" v-show="showLayout" :datas="Data" />
    <suspense><slot class="flex-1" /></suspense>
    <component is="blocks-footer" v-show="showLayout" class="order-9999" :datas="Data" />
    <n-back-top :bottom="100" :visibility-height="300" />
  </div>
</template>
